const Chart = require('chart.js')
const utils = require('frontend-controller/lib/utils')

module.exports = {
	config: {
		chartProperties: {
			type: 'doughnut',
			data: [],
			options: {
				legend: {
					display: false
				},
				tooltips: {
					enabled: false
				},
				hover: {
					animationDuration: 0 // duration of animations when hovering an item
				},
				cutoutPercentage: 25,
				aspectRatio: 1,
				layout: {
					padding: {
						left: 0,
						right: 0,
						top: 0,
						bottom: 0
					}
				}
			}
		},
	},

	model: {
		chartProperties: {}
	},

	methods: {
		initChart: function(){
			if(!this.model.chart && this.$.length > 0){
				this.model.chart = new Chart(this.$.find('> .canvasContainer > canvas'), this.model.chartProperties)
			}
		},

		update(data){
			this.initChart()
			const attributes = (data || {}).attributes

			if(this.model.chart && attributes){
				const {
					reportHours,
					targetWorkingHours,

					standardWorkingHours,
					overtimeWorkingHours,

					workingHours,
					dayWorkingHours,
					nightWorkingHours,

					travelHours,
					voluntaryHours,
					minDurationCausedExtraHours,

					timeSlotSummary,
				} = attributes

				const vacationHours = ((timeSlotSummary || {}).vacation || {}).nrOfHours || 0
				const sickLeaveHours = ((timeSlotSummary || {}).sickLeave || {}).nrOfHours || 0

				const overTargetWorkingHours = Math.max(0, reportHours - targetWorkingHours)
				const underTargetWorkingHours = Math.max(0, targetWorkingHours - reportHours)
				const underTargetWorkingOnlyHours = Math.max(0, targetWorkingHours - workingHours)
				const underReportWorkingOnlyHours = Math.max(0, reportHours - workingHours)


				if(targetWorkingHours > 0){
					if(reportHours < targetWorkingHours){
						this.model.chart.data.labels = [

							// DATASET: 0
							`Std: ${	utils.number.format(standardWorkingHours, { suffix: ' h' }, 'float').formatted				}`,
							`ÜSt-50: ${utils.number.format(overtimeWorkingHours, { suffix: ' h' }, 'float').formatted				}`,

							'',

							// DATASET: 1
							`Tag: ${		utils.number.format(dayWorkingHours, { suffix: ' h' }, 'float').formatted				}`,
							`Nacht: ${		utils.number.format(nightWorkingHours, { suffix: ' h' }, 'float').formatted				}`,

							`Fahrt: ${		utils.number.format(travelHours, { suffix: ' h' }, 'float').formatted					}`,
							`Freiw.: ${		utils.number.format(voluntaryHours, { suffix: ' h' }, 'float').formatted					}`,
							`Pauschal: ${	utils.number.format(minDurationCausedExtraHours, { suffix: ' h' }, 'float').formatted	}`,

							`Urlaub: ${		utils.number.format(vacationHours, { suffix: ' h' }, 'float').formatted					}`,
							`Krank: ${	utils.number.format(sickLeaveHours, { suffix: ' h' }, 'float').formatted					}`,

							'',

							// DATASET: 2
							`Ist: ${		utils.number.format(reportHours, { suffix: ' h' }, 'float').formatted					}`,
							`Übertrag: ${	utils.number.format(-underTargetWorkingHours, { suffix: ' h' }, 'float').formatted		}`,
						]
						this.model.chart.data.datasets[0].data = [
							standardWorkingHours, overtimeWorkingHours, underTargetWorkingOnlyHours,
							0, 0, 0, 0, 0, 0, 0, 0,
							0, 0,
							0
						]
						this.model.chart.data.datasets[1].data = [
							0, 0, 0,
							dayWorkingHours, nightWorkingHours, travelHours, voluntaryHours, minDurationCausedExtraHours, vacationHours, sickLeaveHours, underTargetWorkingHours,
							0, 0,
							0
						]
						this.model.chart.data.datasets[2].data = [
							0, 0, 0,
							0, 0, 0, 0, 0, 0, 0, 0,
							reportHours, underTargetWorkingHours,
							0
						]
						for(let d = 0; d < 3; d++){
							this.model.chart.data.datasets[d].backgroundColor[12] = '#B20000'
							this.model.chart.data.datasets[d].hoverBackgroundColor[12] = '#B20000'
						}
					} else {
						this.model.chart.data.labels = [

							// DATASET: 0
							`Std: ${		utils.number.format(standardWorkingHours, { suffix: ' h' }, 'float').formatted			}`,
							`ÜSt-50: ${		utils.number.format(overtimeWorkingHours, { suffix: ' h' }, 'float').formatted			}`,

							'',

							// DATASET: 1
							`Tag: ${		utils.number.format(dayWorkingHours, { suffix: ' h' }, 'float').formatted				}`,
							`Nacht: ${		utils.number.format(nightWorkingHours, { suffix: ' h' }, 'float').formatted				}`,

							`Fahrt: ${		utils.number.format(travelHours, { suffix: ' h' }, 'float').formatted					}`,
							`Freiw.: ${		utils.number.format(voluntaryHours, { suffix: ' h' }, 'float').formatted					}`,
							`Pauschal: ${	utils.number.format(minDurationCausedExtraHours, { suffix: ' h' }, 'float').formatted	}`,

							`Urlaub: ${		utils.number.format(vacationHours, { suffix: ' h' }, 'float').formatted					}`,
							`Krank: ${	utils.number.format(sickLeaveHours, { suffix: ' h' }, 'float').formatted						}`,

							'',

							// DATASET: 2
							`Soll: ${		utils.number.format(targetWorkingHours, { suffix: ' h' }, 'float').formatted				}`,
							`Übertrag: ${	utils.number.format(overTargetWorkingHours, { suffix: ' h' }, 'float').formatted			}`,
						]
						this.model.chart.data.datasets[0].data = [
							standardWorkingHours, overtimeWorkingHours, underReportWorkingOnlyHours,
							0, 0, 0, 0, 0, 0, 0, 0,
							0, 0
						]
						this.model.chart.data.datasets[1].data = [
							0, 0, 0,
							dayWorkingHours, nightWorkingHours, travelHours, voluntaryHours, minDurationCausedExtraHours, vacationHours, sickLeaveHours, 0,
							0, 0
						]
						this.model.chart.data.datasets[2].data = [
							0, 0, 0,
							0, 0, 0, 0, 0, 0, 0, 0,
							targetWorkingHours, overTargetWorkingHours
						]
						for(let d = 0; d < 3; d++){
							this.model.chart.data.datasets[d].backgroundColor[12] = '#006E00'
							this.model.chart.data.datasets[d].hoverBackgroundColor[12] = '#006E00'
						}
					}
				} else {
					this.model.chart.data.labels = []
					this.model.chart.data.datasets[0].data = []
					this.model.chart.data.datasets[1].data = []
					this.model.chart.data.datasets[2].data = []
				}

				const $legend = this.$.find('.legend')
				$legend.html(this.model.chart.generateLegend())
				// hide empty elements from legend
				// $legend.find('ul > li:nth-child(3), ul > li:nth-child(11), ul > li:nth-child(14)').hide()
				this.model.chart.update()
			}
		},
	},

	hooks: {
		attach: function($element, options){
			// in case of refreshes the chart-dom-binding has to be renewed
			if (this.model.chart && (options || {}).refresh){
				this.model.chart.destroy()
				delete this.model.chart
			}
			if(!this.model.chart){
				this.model.chartProperties = this.config.chartProperties
				this.model.chartProperties.data = {
					datasets: [
						{
							data: [],
							backgroundColor: [
								'#FF9100',
								'#FF6007',

								'#FCFCFC',

								'#ECCB00',
								'#3076B2',

								'#850D81',
								'#A93FA6',
								'#CC7CC9',

								'#057968',
								'#30B4A1',

								'#FCFCFC',

								'#90C190',
								'#B20000',
							],
							hoverBackgroundColor: [
								'#FF9100',
								'#FF6007',

								'#FCFCFC',

								'#ECCB00',
								'#3076B2',

								'#850D81',
								'#A93FA6',
								'#CC7CC9',

								'#057968',
								'#30B4A1',

								'#FCFCFC',

								'#90C190',
								'#B20000',
							],
							borderColor: [
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
							],
							categoryPercentage: 1,
							barPercentage: 1,
						},
						{
							data: [],
							backgroundColor: [
								'#FF9100',
								'#FF6007',

								'#FCFCFC',

								'#ECCB00',
								'#3076B2',

								'#850D81',
								'#A93FA6',
								'#CC7CC9',

								'#057968',
								'#30B4A1',

								'#FCFCFC',

								'#90C190',
								'#B20000',
							],
							hoverBackgroundColor: [
								'#FF9100',
								'#FF6007',

								'#FCFCFC',

								'#ECCB00',
								'#3076B2',

								'#850D81',
								'#A93FA6',
								'#CC7CC9',

								'#057968',
								'#30B4A1',

								'#FCFCFC',

								'#90C190',
								'#B20000',
							],
							borderColor: [
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
							],
							categoryPercentage: 1,
							barPercentage: 1,
						},
						{
							data: [],
							backgroundColor: [
								'#FF9100',
								'#FF6007',

								'#FCFCFC',

								'#ECCB00',
								'#3076B2',

								'#850D81',
								'#A93FA6',
								'#CC7CC9',

								'#057968',
								'#30B4A1',

								'#FCFCFC',

								'#90C190',
								'#B20000',
							],
							hoverBackgroundColor: [
								'#FF9100',
								'#FF6007',

								'#FCFCFC',

								'#ECCB00',
								'#3076B2',

								'#850D81',
								'#A93FA6',
								'#CC7CC9',

								'#057968',
								'#30B4A1',

								'#FCFCFC',

								'#90C190',
								'#B20000',
							],
							borderColor: [
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
								'#FCFCFC',
							],
							categoryPercentage: 1,
							barPercentage: 1,
						},
					]
				}
				this.initChart()
			}

			// update immediately in case of inner propertiesForm usage.
			this.closest('templates_office_employeeReports_propertiesForm', propertiesForm => {
				if((propertiesForm.resourceData || {}).data){
					this.update(propertiesForm.resourceData.data)
				}
			})
		},

		update: function($element, options) {
			this.update((options || {}).employeeReportData)
		},
	}
}